import { matchPath } from "react-router-dom";
import { DataConfirmPath } from "../../features/login/confirm-data/route";
import { ResetPasswordPath } from "../../features/login/reset-password/route";
import { PublicShipmentDetailsPath } from "../../features/shipments/public-shipment-details/route";
import { EmailConfirmPath } from "../../features/settings/email-confirm/route";
import { ReportsPath } from "../../features/reports/route";
import { SignupByInvitePath } from "../../features/signup-by-invite/route";

export interface PublicRoutePattern {
  path: string;
  exact?: boolean;
}

/** Path patterns for routes that do not require authentication. Keep in sync with publicRoutesComponents in RoutesConfig.ts. */
export const publicRoutePaths = {
  authCallback: "/auth-callback",
  resetPassword: `/users/reset-password/:${ResetPasswordPath.token}`,
  signupByInvite: `/users/invite/:${SignupByInvitePath.token}`,
  forgotPassword: "/forgot-password",
  portalRegistration: "/portal-registration",
  confirmData: "/confirm-data",
  dataConfirm: `/users/confirm/:${DataConfirmPath.token}`,
  emailConfirm: `/users/email-confirm/:${EmailConfirmPath.token}`,
  shipmentTracking: `/shipment-tracking/:${PublicShipmentDetailsPath.probill}`,
  reportUnsubscribe: `/unsubscribe/report/:${ReportsPath.id}/:${ReportsPath.email}`,
} as const;

export const publicRoutePatterns: PublicRoutePattern[] = Object.values(publicRoutePaths).map(
  (path) => ({ path })
);

export const isPublicRoute = (pathname: string): boolean =>
  publicRoutePatterns.some((route) =>
    matchPath(pathname, { path: route.path, exact: route.exact })
  );
